<template>
	<div class="w-full">
        <!-- chasers -->
        <div class="flex flex-wrap -mx-3">
			<!-- <div class="w-full flex"> -->
				<Card class="w-full mb-6 lg:w-1/2 lg:mb-0 px-3 flex-grow" :wantsFullHeight="true">
					<template v-slot:header>
						Sales (Numerical)
					</template>
					<template v-slot:body>
						<div class="w-full px-5 pt-5 pb-2">
							<button class="px-2 py-1 bg-green-600 rounded text-white" type="button" v-on:click="exportData()">
								<span v-if="loadingReport"><i class="fas fa-circle-notch fa-spin"></i> Loading</span>
								<span v-if="!loadingReport"><i class="fas fa-file-excel mr-1"></i> Export</span>
							</button>
							<div class="float-right">
								<Dropdown class="ml-auto mt-5 lg:mt-0">
									<template #trigger="{ hasFocus, isOpen }">
										<div class="px-2 py-1 text-white rounded" :class="[(hasFocus || isOpen) ? 'bg-blue-500' : 'bg-blue-700']">
											{{ view.title }} <i class="fa fa-caret-down ml-1"></i>
										</div>
									</template>
									<template #dropdown>
										<div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl text-left">
											<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': view.title == 'Today'}" @click="changeView('today', 'Last 24 hours')">Last 24 hours</a>
											<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': view.title == 'Week'}" @click="changeView('week', 'Week')">Week</a>
											<a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': view.title == 'Month'}" @click="changeView('month', 'Month')">Month</a>
										</div>
									</template>
								</Dropdown>
							</div>
						</div>
						<canvas id="salesChart" class="p-3"></canvas>
					</template>
				</Card>

				<Card class="w-full mb-6 lg:w-1/2 lg:mb-0 px-3 flex-grow" :wantsFullHeight="true">
					<template v-slot:header>
						Sales (Stringer Cut)
					</template>
					<template v-slot:body>
						<p class="text-center py-5">Coming Soon<sup>TM</sup></p>
					</template>
				</Card>
			<!-- </div> -->

			<Card class="w-full mb-6 px-3 mt-6">
				<template v-slot:header>
					Sales List
				</template>
				<template v-slot:body>

					<CustomTable>
						<template v-slot:header>
							<th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
							<th class="py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light pl-2">Invoice</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Purchasing Network</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Sale Date</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Sale Amount</th>
						</template>
						<template v-slot:body>
							<tr v-for="sale in sales">
								<td class="py-4 pl-4 border-b border-grey-light">
									<span class="w-2 h-2 rounded-full bg-yellow-600 inline-block cursor-pointer" v-if="sale.status == 'occurring'" title="Processing" v-tippy></span>
									<span class="w-2 h-2 rounded-full bg-green-600 inline-block cursor-pointer" v-if="sale.status == 'complete'" title="Complete" v-tippy></span>
								</td>
								<td class="py-4 px-6 border-b border-grey-light pl-2">{{ sale.invoice_number }}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ sale.video.title }}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ sale.network.name }}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ sale.created_at | displayLocalDateTime }}</td>
								<td class="py-4 px-6 border-b border-grey-light text-right">${{ sale.stringer_cut }}</td>
							</tr>  
							<tr v-if="sales.length !== 0">
								<td colspan="5" class="border-b border-grey-light text-right">Total:</td>
								<td class="py-4 px-6 border-b border-grey-light text-right">${{ total }}</td>
							</tr>
							<tr v-if="sales.length == 0">
								<td colspan="6" class="text-center">You currently have no sales.</td>
							</tr>
							<tr class="bg-grey-lighter text-center" v-if="polling">
								<td class="py-5" colspan="6">
									<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
								</td>
							</tr>
						</template>
					</CustomTable>
				</template>
			</Card>
        </div>
    </div>
</template>

<script>
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import Chart from 'chart.js';
	import _ from 'lodash'
	import download from 'downloadjs'

	import Card from '@/components/partials/Card'
	import CustomTable from '@/components/general/CustomTable'
	import Dropdown from '@/components/partials/Dropdown'

	export default {
		name: 'HelloWorld',
		data () {
			return {
                sales: {},
                total: 0,

                graphData: null,
				chart: null,
				canvas: null,
				content: null,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				view: {
					param: 'month',
					title: 'Month',
				},
				loadingReport: false,
				polling: true,
			}
		},
		components: {
			Card,
			CustomTable,
			Dropdown
		},
        mounted() {
            this.canvas = document.getElementById('salesChart')
			this.context = this.canvas.getContext('2d')
		
            this.getSalesGraphData();
            
            this.getSales();
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getSales() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/stringer/sales", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'sales', response.data)
                    this.$set(this, 'polling', false)
                    this.calculateTotal();
                });
            },
            calculateTotal() {
                if(this.sales.length > 0) {
                    var total = 0
					this.sales.forEach(function(sale) {
						total += sale.stringer_cut
					})
                    this.total = total;
                }
            },
            getSalesGraphData() {
				return this.$http.get(Config.apiPath + "/api/v2/stringer/graphs/sales", {
					headers: this.getAuthorizationHeader()['headers'],
					params: {
						filter: this.view.param,
						timezone: this.timezone,
					}
				}).then((response) => {
					this.graphData = response.data
					this.createSalesGraph();
                });
			},

			changeView (param, title) {
				// Don't reload the same view.
				if (this.view.param === param) return
				this.view = {
					param: param,
					title: title
				}
				this.getSalesGraphData().then(this.updateChart)
			},

			createSalesGraph() {

				if (this.chart !== null) {
					this.chart.destroy()
				}

				var data_keys = _.keys(this.graphData);
				if (0 < data_keys.length && data_keys[0].length > 10) {
					for (var i = 0; i < data_keys.length; i++) {
						data_keys[i] = data_keys[i].substr(11);
					}
				}

				this.chart = new Chart(this.context, {
					type: 'line',
					data: {
						labels: data_keys,
						datasets: [{
							data: _.values(this.graphData),
							backgroundColor: 'rgba(0,85,161,0.4)',
							borderColor: 'rgba(0,85,161,0.6)',
							// borderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBackgroundColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBorderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointHoverBackgroundColor: "{{ color_darken($theme_metrics, -0.2) }}",
							// pointHoverBorderColor: "{{ color_darken($theme_metrics, -0.2) }}"
						}]
					},
					options: {
						scales: {
							yAxes: [{
								ticks: {
									beginAtZero: true,
									suggestedMax: 0.1,
									// fixedStepSize: result.data.metric.places,
									callback: function(tickValue, index, ticks) {
										let delta = ticks[1] - ticks[0]
										// If we have a number like 2.5 as the delta, figure out how many decimal places we need
										if (Math.abs(delta) > 1) {
											if (tickValue !== Math.floor(tickValue)) {
												delta = tickValue - Math.floor(tickValue)
											}
										}
										const logDelta = Chart.helpers.log10(Math.abs(delta))
										let tickString = ''
										if (tickValue !== 0) {
											let numDecimal = -1 * Math.floor(logDelta)
											numDecimal = Math.max(Math.min(numDecimal, 2), 0) // Use as many places as the metric defines
											tickString = tickValue.toFixed(numDecimal)
										} else {
											tickString = '0' // Never show decimal places for 0
										}
										return tickString
									}
								}
							}]
						},
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									if(tooltipItem.yLabel == 1) {
										return tooltipItem.yLabel + " sale";
									}
									return tooltipItem.yLabel + " sales";	
								}
							}
						},
						legend: {
							display: false
						},
				}})
			
            },
            
			exportData() {
				this.loadingReport = true;

				return this.$http.get(Config.apiPath + "/api/v2/stringer/export/sales", {
					responseType: 'blob',
					headers: {
						'Authorization': this.getAuthorizationHeader()['headers']['Authorization'],
						'Accept': 'application/vnd.ms-excel',
					},
					params: {
						filter: this.view.param,
						timezone: this.timezone,
					}
				}).then((response) => {
					download(new Blob([response.data]), moment.utc(new Date()).format("MM-DD-YYYY") + '-sales-report-' + this.view.param + '.xlsx')
					this.loadingReport = false;
                });
			}
        },
        filters: {
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
			displayStatus: function(data) {
                if(data == 'pending') {
                    return "Pending"
                } else if(data == 'occurring') {
                    return "Occurring"
                } else if(data == 'complete') {
                    return "Complete"
                }
            },
        }
	}
</script>

<style scoped>

</style>
